module.exports = __webpack_public_path__ + "static/media/image.51e83f75.svg";